import type { CardDef } from '../types/cards';
import { copies, cost, neighborsCards, produce, produceOne, science, shields, vp } from './helpers';

/**
 * Era II (2ª edición): 49 cartas (incluye las copias de Era II de Telar, Vidriería y Prensa,
 * definidas en age1.ts). Las manos pasan a la DERECHA.
 */
export const AGE2_CARDS: CardDef[] = [
  // Marrones
  { id: 'sawmill', color: 'brown', cost: cost('1$'), effects: [produce('WW')], copies: copies(2, 3, 4) },
  { id: 'quarry', color: 'brown', cost: cost('1$'), effects: [produce('SS')], copies: copies(2, 3, 4) },
  { id: 'brickyard', color: 'brown', cost: cost('1$'), effects: [produce('CC')], copies: copies(2, 3, 4) },
  { id: 'foundry', color: 'brown', cost: cost('1$'), effects: [produce('OO')], copies: copies(2, 3, 4) },
  // Azules
  { id: 'courthouse', color: 'blue', cost: cost('CCL'), effects: [vp(4)], chainFrom: ['scriptorium'], copies: copies(2, 3, 5) },
  { id: 'temple', color: 'blue', cost: cost('WCG'), effects: [vp(4)], copies: copies(2, 3, 6) },
  { id: 'statue', color: 'blue', cost: cost('OOW'), effects: [vp(4)], chainFrom: ['well'], copies: copies(2, 3, 7) },
  { id: 'aqueduct', color: 'blue', cost: cost('SSS'), effects: [vp(5)], chainFrom: ['baths'], copies: copies(2, 3, 7) },
  // Amarillas
  {
    id: 'caravansery',
    color: 'yellow',
    cost: cost('WW'),
    effects: [produceOne('WSOC')],
    chainFrom: ['marketplace'],
    copies: copies(2, 3, 5, 6),
  },
  {
    id: 'forum',
    color: 'yellow',
    cost: cost('CC'),
    effects: [produceOne('GPL')],
    chainFrom: ['east_trading_post', 'west_trading_post'],
    copies: copies(2, 3, 6, 7),
  },
  {
    id: 'vineyard',
    color: 'yellow',
    cost: cost(''),
    effects: [{ kind: 'coinsPer', count: neighborsCards(['brown']), scopes: ['self', 'left', 'right'], amount: 1 }],
    copies: copies(2, 3, 6),
  },
  {
    id: 'bazaar',
    color: 'yellow',
    cost: cost(''),
    effects: [{ kind: 'coinsPer', count: neighborsCards(['grey']), scopes: ['self', 'left', 'right'], amount: 2 }],
    copies: copies(2, 4, 7),
  },
  // Rojas
  { id: 'stables', color: 'red', cost: cost('WOC'), effects: [shields(2)], chainFrom: ['apothecary'], copies: copies(2, 3, 5) },
  { id: 'archery_range', color: 'red', cost: cost('WWO'), effects: [shields(2)], chainFrom: ['workshop'], copies: copies(2, 3, 6) },
  { id: 'walls', color: 'red', cost: cost('SSS'), effects: [shields(2)], copies: copies(2, 3, 7) },
  { id: 'training_ground', color: 'red', cost: cost('OOW'), effects: [shields(2)], copies: copies(2, 4, 6, 7) },
  // Verdes
  { id: 'dispensary', color: 'green', cost: cost('OOG'), effects: [science('compass')], chainFrom: ['apothecary'], copies: copies(2, 3, 4) },
  { id: 'laboratory', color: 'green', cost: cost('CCP'), effects: [science('gear')], chainFrom: ['workshop'], copies: copies(2, 3, 5) },
  { id: 'library', color: 'green', cost: cost('SSL'), effects: [science('tablet')], chainFrom: ['scriptorium'], copies: copies(2, 3, 6) },
  { id: 'school', color: 'green', cost: cost('WP'), effects: [science('tablet')], copies: copies(2, 3, 7) },
];
